export const categories = [
  {
    slug: 'animation',
    name: '动画',
    short: '新番 · 名场面 · 混剪',
    icon: 'ri-movie-2-line',
    description:
      '收录当季新番、经典神作与高燃混剪，从热血战斗到治愈日常，宅男们的二次元充电站。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20anime%20city%20skyline%20at%20sunset%2C%20vivid%20orange%20and%20deep%20blue%20gradient%2C%20dramatic%20lighting%2C%20digital%20illustration%2C%20clean%20composition%2C%20high%20detail&width=800&height=450&seq=cat-animation&orientation=landscape',
  },
  {
    slug: 'game',
    name: '游戏',
    short: '速评 · 集锦 · 攻略',
    icon: 'ri-gamepad-line',
    description:
      '新游速评、高光集锦、硬核攻略一网打尽，主机、PC 到手游，陪你把每一局都打得漂亮。',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20gaming%20setup%20with%20neon%20orange%20and%20deep%20blue%20lighting%2C%20abstract%20digital%20arena%2C%20dynamic%20glow%2C%20stylized%20illustration%2C%20clean%20composition&width=800&height=450&seq=cat-game&orientation=landscape',
  },
  {
    slug: 'clip',
    name: '影视片段',
    short: '高燃 · 反转 · 混剪',
    icon: 'ri-film-line',
    description:
      '动作、科幻、悬疑、喜剧精彩片段精选，几分钟看完电影最过瘾的瞬间，碎片时间也过瘾。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20silhouette%20on%20deep%20blue%20stage%20with%20warm%20orange%20spotlight%2C%20dramatic%20mood%2C%20stylized%20movie%20poster%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=cat-clip&orientation=landscape',
  },
];